// @ts-nocheck
/* eslint-disable react/prop-types */
import React from 'react';
import { Divider as MuiDivider } from '@mui/material';

// Default props as constants
const DEFAULT_ORIENTATION = 'horizontal';
const DEFAULT_VARIANT = 'fullWidth';
const DEFAULT_FLEX_ITEM = false;
const DEFAULT_LIGHT = false;
const DEFAULT_ABSOLUTE = false;

/**
 * SolyticsDivider - A wrapper around MUI Divider component
 *
 * A divider is a thin line that groups content in lists and layouts.
 * Supports horizontal and vertical orientations with various styling options.
 *
 * @component
 * @example
 * // Basic horizontal divider
 * <SolyticsDivider />
 *
 * @example
 * // Divider with text
 * <SolyticsDivider>OR</SolyticsDivider>
 *
 * @example
 * // Vertical divider
 * <SolyticsDivider orientation="vertical" flexItem />
 *
 * @example
 * // Custom styled divider
 * <SolyticsDivider color="rgba(0, 0, 0, 0.2)" height={2} />
 */
const SolyticsDivider = ({
  children,
  orientation = DEFAULT_ORIENTATION,
  variant = DEFAULT_VARIANT,
  flexItem = DEFAULT_FLEX_ITEM,
  light = DEFAULT_LIGHT,
  absolute = DEFAULT_ABSOLUTE,
  textAlign,
  component,
}) => {
  // Build props object for MUI Divider
  const dividerProps = {
    orientation,
    variant,
    flexItem,
    light,
    absolute,
    ...(component && { component }),
    ...(children && textAlign && { textAlign }),
    sx: (theme) => ({
      borderColor: theme.palette.divider,
    }),
  };

  return <MuiDivider {...dividerProps}>{children}</MuiDivider>;
};

export default SolyticsDivider;
